import { Col } from "@commonlibs";
import styled, { css } from "styled-components";

export const UploadLoadingRoot = styled(Col)(
    ({ theme: { palette, spacing } }) => css`
        background-color: ${palette.overlays[900][60]};
        border-radius: 50%;
        padding: ${spacing["1.5"]};
        .Loader {
            color: ${palette.gray[0]};
        }
        &.sm {
            padding: ${spacing["1"]};
            .Loader {
                font-size: 1rem;
            }
        }
    `,
);
